import { ArrowForward, Toll } from "@mui/icons-material";
import { Box, IconButton, InputBase, Paper, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { AccountContext } from "services/account";

interface Props {
	handleSubmit: (value?: any) => Promise<any>;
	inputValue: string;
	setInputValue: React.Dispatch<React.SetStateAction<string>>;
	loading?: boolean;
}
interface ChatInputRef {
	updateCredit: (number: number) => any;
}

const ChatInput = React.forwardRef<ChatInputRef, Props>(({ handleSubmit, inputValue, setInputValue }, ref) => {
	const { t } = useTranslation("common");
	const account = React.useContext(AccountContext);

	const [submitLoading, setSubmitLoading] = React.useState(false);
	const [credit, setCredit] = React.useState(account.value.paidCredit || 0);

	const handleKeyInput = (e: React.KeyboardEvent) => {
		const nextLine = e.shiftKey;
		if (e.key === "Enter" && !nextLine) {
			e.preventDefault();
			onSubmit(e);
		}
	};

	const onSubmit = async (e: React.FormEvent) => {
		if (submitLoading || !inputValue) return;
		e.preventDefault();
		setSubmitLoading(true);
		await handleSubmit();
		setSubmitLoading(false);
	};

	React.useImperativeHandle(ref, () => {
		return {
			updateCredit: (credit: number) => setCredit(credit),
		};
	});

	return (
		<Paper
			component="form"
			onSubmit={onSubmit}
			sx={{
				width: 1,
				p: 1,
				boxSizing: "border-box",
				border: "1px solid",
				borderColor: "divider",
				"&:focus-within": { borderColor: "primary.main" },
			}}>
			<InputBase
				fullWidth
				multiline
				maxRows={5}
				name="question"
				value={inputValue}
				onChange={(e) => setInputValue(e.target.value)}
				onKeyDown={handleKeyInput}
				sx={{ ml: 1, flex: 1 }}
				placeholder={t("typeSomething")}
			/>
			<Box
				display="flex"
				justifyContent="space-between">
				<Box></Box>
				<Box
					display="flex"
					flexDirection="row"
					alignItems="center">
					<Toll sx={{ color: "text.secondary", mr: 0.5 }} />
					<Typography color="text.secondary">{credit}</Typography>
					<IconButton
						type="submit"
						size="small"
						disabled={!inputValue || submitLoading}>
						<ArrowForward />
					</IconButton>
				</Box>
			</Box>
		</Paper>
	);
});

export default ChatInput;
